export default "__VITE_ASSET__CvnCMiL3__"